export default __webpack_public_path__ + "static/media/GothamSSm-Book.6b97b34a.svg";